module.exports = __webpack_public_path__ + "img/img8.5a332767.png";